module.exports = __webpack_public_path__ + "img/Group12460@2x.b8472e7a.png";